import { Grid, Text, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { renderYesNoValue } from 'utils/general';
import { PaperHeader } from 'components/PaperHeader/PaperHeader';
import { PatientIdProps } from 'models/general';
import { useProfile } from 'hooks/api/useProfile';
import { CenteredLoading } from 'components/CenteredLoading';

export const PatientQuestionnaire = ({ patientId }: PatientIdProps) => {
  const { t } = useTranslation();
  const { data: patientProfile, isLoading } = useProfile(patientId);
  const patientAnswers: Record<string, string> | undefined = patientProfile?.customFields;

  if (isLoading) return <CenteredLoading />;

  return (
    <>
      <PaperHeader
        titleKey={'patients_questionnaire'}
        iconKey={'patientdetails_personalhealthinfo_medicalquestionnaire_tooltip'}
      />
      <Stack mt={20}>
        <Grid align={'center'}>
          <Grid.Col span={6}>
            <Text>{t('questionnaire_hypertension')}</Text>
          </Grid.Col>
          <Grid.Col offset={1} span={5}>
            <Text>{renderYesNoValue(patientAnswers?.hypertension)}</Text>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text>{t('questionnaire_diabetes')}</Text>
          </Grid.Col>
          <Grid.Col offset={1} span={5}>
            <Text>{renderYesNoValue(patientAnswers?.diabetes)}</Text>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text>{t('questionnaire_vascular_disease')}</Text>
          </Grid.Col>
          <Grid.Col offset={1} span={5}>
            <Text>{renderYesNoValue(patientAnswers?.arteryDisease)}</Text>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text>{t('questionnaire_heart_failure')}</Text>
          </Grid.Col>
          <Grid.Col offset={1} span={5}>
            <Text>{renderYesNoValue(patientAnswers?.heartFailure)}</Text>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text>{t('questionnaire_thrombosis')}</Text>
          </Grid.Col>
          <Grid.Col offset={1} span={5}>
            <Text>{renderYesNoValue(patientAnswers?.stroke)}</Text>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text>{t('questionnaire_pacemaker')}</Text>
          </Grid.Col>
          <Grid.Col offset={1} span={5}>
            <Text>{renderYesNoValue(patientAnswers?.pacemaker)}</Text>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text>{t('questionnaire_arrhythmia')}</Text>
          </Grid.Col>
          <Grid.Col offset={1} span={5}>
            <Text>{renderYesNoValue(patientAnswers?.arrhythmias)}</Text>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text>{t('questionnaire_atrial_fibrillation')}</Text>
          </Grid.Col>
          <Grid.Col offset={1} span={5}>
            <Text>{renderYesNoValue(patientAnswers?.atrialFibrillation)}</Text>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text>{t('questionnaire_risk_atrial_fibrillation')}</Text>
          </Grid.Col>
          <Grid.Col offset={1} span={5}>
            <Text>{renderYesNoValue(patientAnswers?.atrialFibrillationKnowledge)}</Text>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text>{t('questionnaire_anticoagulants')}</Text>
          </Grid.Col>
          <Grid.Col offset={1} span={5}>
            <Text>{renderYesNoValue(patientAnswers?.bloodThinner)}</Text>
          </Grid.Col>
        </Grid>
      </Stack>
    </>
  );
};
